export const emergencyPlaningSchema = {
  title: "Emergency Planning",
  type: "object",
  properties: {
    emergencyPlanningSection0: {
      type: "object",
      title: "Emergency Planning",
      description: "Required by Texas Administrative Code",
      required: ["stearRegistration"],
      properties: {
        priorityLevel: {
          type: "string",
          enum: ["Low", "Medium", "High"],
          default: "Medium",
        },
        stearRegistration: {
          type: "boolean",
          errorMessage: {
            required: "STEAR Registration required",
          },
        },
        notes: {
          type: "string",
        },
      },
      dependencies: {
        stearRegistration: {
          oneOf: [
            {
              properties: {
                stearRegistration: { const: true },
                notes: {
                  type: "string",
                  maxLength: 500,
                  errorMessage: {
                    maxLength: "Notes must be at most 500 characters.",
                  },
                },
              },
            },
            {
              properties: {
                stearRegistration: { const: false },
              },
            },
          ],
        },
      },
    },
  },
};

export const emergencyPlaningUiSchema = {
  emergencyPlanningSection0: {
    "ui:field": "EmergencyPlanningField",
  },
};
